import React, { useState } from "react";
import {useEffect} from "react";
import {insertCompany} from "./Services/insertCompany";
import { fetchRole } from "./Services/fetchRole";
import { fetchComType} from "./Services/fetchComType";

const CreateCompany = () => {
     useEffect(() => {
        const scriptUrls = [
          'assets/js/jquery.min.js',
          'assets/js/bootstrap.bundle.min.js',
          'assets/js/moment.min.js',
          'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
          'assets/vendor/overlay-scroll/custom-scrollbar.js',
          'assets/vendor/daterange/daterange.js',
          'assets/vendor/daterange/custom-daterange.js',
          'assets/js/custom.js'
        ];
    
        let isCancelled = false;
        
        // Load scripts sequentially
        const loadScriptsSequentially = async () => {
          for (const url of scriptUrls) {
            if (isCancelled) break;
    
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = url;
              script.onload = resolve;
              script.onerror = reject;
              document.body.appendChild(script);
            });
          }
        };
    
        loadScriptsSequentially();
    
        return () => {
          isCancelled = true;
          // Optionally remove scripts if needed
        };
      }, []);
         const [companyId, setCompanyId] = useState(null);
         const [companyName, setCompanyName] = useState("");
         const [comTypeId, setComTypeId] = useState(null);
         const [companyIdPrefix, setCompanyIdPrefix] = useState("");
         const [companyIdNo, setCompanyIdNo] = useState("");
         const [companyRegNo, setCompanyRegNo] = useState("");
         const [companyGstNo, setCompanyGstNo] = useState("");
         const [logoImg, setLogoImg] = useState(null);
         const [officeAddress, setOfficeAddress] = useState("");
         const [branchLocation, setBranchLocation] = useState("");
         const [phoneNumber, setPhoneNumber] = useState("");
         const [emailAddress, setEmailAddress] = useState("");
         const [websiteUrl, setWebsiteUrl] = useState("");
         const [emergencyContact, setEmergencyContact] = useState("");
         const [primaryPerson, setPrimaryPerson] = useState("");
         const [rolesId, setRolesId] = useState(null);
         const [priPersonContactNo, setPriPersonContactNo] = useState("");
         const [comPassword, setComPassword] = useState("");
         const [comConPassword, setComConPassword] = useState("");
         
         
         const handleSubmit = async (e) => {
          e.preventDefault();
          if(comPassword===comConPassword){
            const formData = new FormData();
    formData.append("companyName", companyName);
    formData.append("companyTypeId", comTypeId);
    formData.append("companyIdPrefix", companyIdPrefix);
    formData.append("companyIdNo", companyIdNo);
    formData.append("companyRegNo", companyRegNo);
    formData.append("companyGstNo", companyGstNo);
    formData.append("logoImg", logoImg); // file
    formData.append("officeAddress", officeAddress);
    formData.append("branchLocation", branchLocation);
    formData.append("phoneNumber", phoneNumber);
    formData.append("emailAddress", emailAddress);
    formData.append("websiteUrl", websiteUrl);
    formData.append("emergencyContact", emergencyContact);
    formData.append("primaryPerson", primaryPerson);
    formData.append("rolesId", rolesId);
    formData.append("priPersonContactNo", priPersonContactNo);
    formData.append("companyPassword", comPassword);
          await insertCompany(formData);
      
          setCompanyName("");
          setComTypeId("");
          setCompanyIdPrefix("");
          setCompanyIdNo("");
          setCompanyRegNo("");
          setCompanyGstNo("");
          setLogoImg("");
          //e.target.files[0]="";
          setOfficeAddress("");
          setBranchLocation("");
          setPhoneNumber("");
          setEmailAddress("");
          setWebsiteUrl("");
          setEmergencyContact("");
          setPrimaryPerson("");
          setRolesId("");
          setPriPersonContactNo("");
          setComPassword("");
          setComConPassword("");
        }else {
          setComPassword("");
          return false;
        }
        };
        const [roles, setRoles] = useState([]);
        const [companyTypes, setCompanyTypes] = useState([]);
        const getRoles =()=> {
          const fetch = async () => {
            const data = await fetchRole();
            setRoles(data);
          };
          fetch();
        }
        const getCompanyTypes =()=>{
          const fetch = async () => {
            const data = await fetchComType();
            setCompanyTypes(data);
          }
          fetch();
        }
        useEffect(()=>{
          getCompanyTypes();
          getRoles();
        }, []);
        const handleFileChange = (e) => {
          setLogoImg(e.target.files[0]);
        };
        
        const handleDropdownChange = (e) => {
          setComTypeId(e.target.value);
          // Don't reset or reload any state unnecessarily here
        };

        const handleRoleChange = (e) => {
          setRolesId(e.target.value);
          // Don't reset or reload any state unnecessarily here
        };
  return(   
<div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="#!">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Create Company
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    {/* <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div> */}
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            {/* Custom tabs starts */}
            <div className="custom-tabs-container">
              {/* Nav tabs starts */}
              <ul className="nav nav-tabs" id="customTab2" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link active" id="tab-oneA" data-bs-toggle="tab" href="#oneA" role="tab" aria-controls="oneA" aria-selected="true" >
                    <i className="ri-profile-line" />
                    Basic
                    Details</a>
                </li>
                
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-twoA" data-bs-toggle="tab" href="#twoA" role="tab" aria-controls="twoA" aria-selected="false" disabled><i className="ri-lock-password-line" /> Create
                    Password</a>
                </li>
                
              </ul>
              {/* Nav tabs ends */}
              {/* Tab content starts */}
              
               
                
              
              <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="tab-content h-350">
                <div className="tab-pane fade show active" id="oneA" role="tabpanel">
                  {/* Row starts */}
                  
                  <div className="row gx-4">
                  <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Basic Info</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a1">Company Name <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <input type="text" className="form-control" id="a1" placeholder="Company Name"
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a2">Company Type <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <select className="form-select" id="a2"
                          value={comTypeId}
                          onChange={handleDropdownChange}>
                             <option value={0}>Select</option>
                            {companyTypes.map((comType)=>(<option 
                            value={comType.companyTypeId}>{comType.companyTypeName}
                            </option>))}                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a31">Company Id  <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <input type="text" className="form-control" id="a31" placeholder="Prefix eg. WT" 
                          value={companyIdPrefix}
                          onChange={(e) => setCompanyIdPrefix(e.target.value)}/>
                          <input type="text" className="form-control" id="a32" placeholder="Id eg. 1001" 
                          value={companyIdNo}
                          onChange={(e) => setCompanyIdNo(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a4">Registration No /Lisence No <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <input type="text" className="form-control" id="a4" placeholder="Registration No"
                           value={companyRegNo}
                           onChange={(e) => setCompanyRegNo(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="gstno">Gst/ Tax ID<span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <input type="text" className="form-control" id="a5" placeholder="Gst No" name="gstno"
                          value={companyGstNo}
                          onChange={(e) => setCompanyGstNo(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a4">Logo /Branding <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-secure-payment-line" />
                          </span>
                          <input type="file" className="form-control" id="a6" placeholder="Choose file"
                          onChange={handleFileChange} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Contact & Address Info</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a7">Head Office Address <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-mail-open-line" />
                          </span>
                          
                          <textarea className="form-control" id="a7" placeholder="office Address"
                           rows={2} defaultValue={""} required
                           value={officeAddress}
                          onChange={(e) => setOfficeAddress(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a8">Branch Locations <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a8" placeholder="Branch Locations"
                          value={branchLocation}
                          onChange={(e) => setBranchLocation(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a9">Phone Number</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a9" placeholder="Phone Numbers"
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a10">Email address</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="email" className="form-control" id="a10" placeholder="Email Address"
                          value={emailAddress}
                          onChange={(e) => setEmailAddress(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a11">Wesbsite Url</label>
                        {/* <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-nft-line" />
                          </span>
                          <select className="form-select" id="a9">
                            <option value={0}>Select</option>
                            <option value={1}>Doctor</option>
                            <option value={2}>Head of the Dept</option>
                          </select>
                        </div> */}
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a11" placeholder="www@example.com"
                          value={websiteUrl}
                          onChange={(e) => setWebsiteUrl(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a12">Emergency Contact<span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a12" placeholder="eg.3213455546"
                          value={emergencyContact}
                          onChange={(e) => setEmergencyContact(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Authorized Personnal</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a13">Primary Contact Person</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-projector-line" />
                          </span>
                          <input type="text" className="form-control" id="a13" placeholder="Contact Info"
                          value={primaryPerson}
                          onChange={(e) => setPrimaryPerson(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a14">Designation/Role</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flag-line" />
                          </span>
                          <select className="form-select" id="a14"
                          value={rolesId}
                          onChange={handleRoleChange}>
                           <option value={0}>Select</option>
                            {roles.map((role)=>(<option 
                            value={role.rolesId}>{role.roleName}
                            </option>))}
                            
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a15">Contact Info</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-projector-line" />
                          </span>
                          <input type="text" className="form-control" id="a15" placeholder="Contact No"
                          value={priPersonContactNo}
                          onChange={(e) => setPriPersonContactNo(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-2 justify-content-end">
              <button type="button" className="btn btn-secondary">
                Cancel
              </button>
              <button type="button" className="btn btn-primary" onClick={() =>{
                const oneA =document.getElementById("oneA")
                const twoA =document.getElementById("twoA");
                const tabOneA =document.getElementById("tab-oneA")
                const tabTwoA =document.getElementById("tab-twoA");
                oneA.classList.remove("show");
                oneA.classList.remove("active");
                twoA.classList.add("show");
                twoA.classList.add("active");
                tabOneA.classList.remove("active");
                tabTwoA.classList.add("active");
                tabTwoA.removeAttribute("disabled");
              }}>
                Next
              </button>
            </div>   
                  </div>
                 
                  {/* Row ends */}
                </div>
                
                <div className="tab-pane fade" id="twoA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row justify-content-center">
                    <div className="col-sm-4 col-12">
                      <div className="card border mb-3">
                        <div className="card-body">
                          
                          <div className="mb-3">
                            <label className="form-label" htmlFor="newPwd">New password <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <input type="password" id="newPwd" className="form-control" placeholder="Your password must be 8-20 characters long."
                               value={comPassword}
                               onChange={(e) => setComPassword(e.target.value)} 
                               required />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-eye-line text-black" />
                              </button>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="confNewPwd">Confirm new password <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <input type="password" id="confNewPwd" placeholder="Confirm new password" className="form-control"
                               value={comConPassword}
                               onChange={(e) => setComConPassword(e.target.value)}  />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-eye-off-line text-black" />
                              </button>
                            </div>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                    <div className="d-flex gap-2 justify-content-end">
              <button type="button" className="btn btn-secondary">
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" >
                Update
              </button>
            </div>               
                  </div>
                  {/* Row ends */}
                </div>
              </div>
              </form>
                 
              {/* Tab content ends */}
            </div>
            {/* Custom tabs ends */}
            {/* Buttons starts */}
            
            {/* Buttons ends */}
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>


  );
}
export default CreateCompany;




